import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBar } from 'primeng/progressbar';
import { LoadingService } from '@services/loading.service';

@Component({
    selector: 'app-loading-overlay',
    standalone: true,
    imports: [CommonModule, ProgressBar],
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent implements OnInit {
    isLoading = false;

    constructor(private loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingService.loading$.subscribe((isLoading) => {
            this.isLoading = isLoading;
        });
    }
}
